import React from 'react'
import { View } from 'react-native'
import tw from 'tailwind-rn'

import { BlockMarkdownType, BlockMenuType } from '../../config/types'
import BlockMenu from './BlockMenu'
import Markdown from './Markdown'

// type Props = {

// }

const BlockSuspicionChecker = () => {
  // const { data } = props

  const data: BlockMenuType = {
    id: '328523948754876',
    type: 'menu',
    items: [
      {
        id: '12534563654653463',
        type: 'custom',
        title: 'Akute Gefährdung',
        description: 'Kindeswohl ist unmittelbar gefährdet',
        routeName: 'SuspicionCheckerAcuteDangerChildren',
      },
      {
        id: '566524654574575',
        type: 'custom',
        title: 'Latente Gefährdung',
        description: 'Kindeswohl ist möglicherweise nicht gewährleistet',
        routeName: 'SuspicionCheckerLatentDangerChildren',
      },
      {
        id: '4239564564975639465',
        type: 'custom',
        title: 'Beratungsbedarf Eltern',
        description: 'Eltern haben Unterstützungsbedarf',
        routeName: 'SuspicionCheckerNeedForAdviceChildren',
      },
    ],
  }

  return (
    <View style={tw('pb-6')}>
      <BlockMenu data={data} />
    </View>
  )
}

export default BlockSuspicionChecker
